import styled from 'styled-components'
import Color from 'constants/colors'

import InputField from './text-field'
import SubmitButton from 'components/buttons/submit-button'

export const TextField = styled(InputField)`
  font-family: ${props=>props.theme.fonts.h5};
  font-weight: bold;
  display: inline-block;
  box-sizing: border-box;
  line-height: 20px;
  text-transform: none;
  letter-spacing: none;
  width: 100%;
  font-size: 16px;
  padding-left: 4px;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-top: 9px;
  margin-bottom: 9px;
  border-left: none;
  border-right: none;
  border-top: none;
  border-bottom: 5px solid #eee;
  outline: none;
  background-color: transparent;
  border-radius: 3px;

  ::placeholder {
    color: #999;
  }
  &:focus {
    transition: background-color 200ms ease-in;
    background-color: rgba(0,0,0,0.025);
    border-bottom: 5px solid ${Color('blue')};
  }
  @media screen and (max-width: 767px) {
    font-size: 16px;
    border-radius: 0;
  }

`;



export const ErrorMessage = styled.div`
  margin-top: 5px;
  font-family: ${props=>props.theme.fonts.h3};
  text-align: center;
  color: ${Color('red')};
`;

export const MoreFields = styled.div`
  font-family: 'Helvetica Neue', 'Helvetica', Arial, sans-serif;
  margin-top: 20px;
  font-size: 13px;
  outline: none;
  display: block;
`;

export const FieldSet = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`;

export const SuccessStyle = styled.div`
  font-family: ${props=>props.theme.fonts.h2};
  font-weight: bold;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  display: block;
  margin-top: 12px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 25px;
  background-color: #C9FFF3;
  color: #333;
  border: 4px solid #C9FFF3;
  -webkit-appearance: none;
  border-radius: 3px;
  text-align: center;
`;

export const SubmitButtonWithStyle = styled(SubmitButton)`
  font-family: ${props=>props.theme.fonts.h2};
  font-weight: bold;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  text-align:center;
  display: block;
  margin-top: 12px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 25px;
  color: ${Color('blue')};
  border: 4px solid ${Color('blue')};
  -webkit-appearance: none;
  border-radius: 3px;

  &:focus {
    background-color: ${Color('blue')};
    color: white;
    text-decoration: underline;
    outline: none;
  }

  @media not all and (hover: none) {
    &:hover{
      background-color: ${Color('blue')};
      color: white;
      cursor: pointer;
    }
  }
`;

export const SubmittingStyle = styled.div`
  font-family: ${props=>props.theme.fonts.h2};
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5em;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  text-align:center;
  display: flex;
  justify-content: center;
  margin-top: 12px;
  margin-left: auto;
  margin-right: auto;
  padding: 10px 25px;
  box-shadow: none;
  background-color: #999;
  color: #666;
  border: 4px solid #999;
  -webkit-appearance: none;
  border-radius: 3px;
`;

export const FormContainer = styled.div`
  padding: 30px 70px;
  border 4px solid black;
  border-radius: 5px;
  @media screen and (max-width: 767px) {
    padding: 20px;
  }
`;

export const FormTitle = styled.h1`
  margin-top: 70px;
  text-align: center;
  margin-bottom: 30px;
`;

export const Title = styled.h4`
  text-align: center;
  margin-top: 70px;
  margin-bottom: 30px;
`;




// WEBPACK FOOTER //
// ./src/components/interactive/forms/form-styles.js